module.exports = __webpack_public_path__ + "img/home_img05.9bde7a3a.png";